import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-gebruiker-centraal',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconGebruikerCentraal {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="m11.2 5.37.12.03c.56.13 1.12.2 1.66.2 2.07 0 4.08-.86 5.53-2.36l1.6-1.58 1.37 1.36a7.68 7.68 0 0 0 3.07 2.09l.22.08-.07-.23C23.81 2.04 21.05 0 18.01 0s-5.97 2.16-6.77 5.25l-.03.11Zm-.18 2.06v.16C11.33 11.19 14.4 14 18 14s6.76-2.89 6.98-6.58v-.1l-.65-.13a9.545 9.545 0 0 1-4.15-2.77l-.09-.1-.09.1c-1.79 2.06-4.36 3.24-7.03 3.24-.59 0-1.19-.07-1.8-.19l-.15-.03Zm12.94 8.01H12.95c-2.98 0-3.98 1.01-4.98 5.01l-.95 4.27 4.8-3.36 2.4 3.82-3.25 2.28v6.99c0 .55.45 1 1 1h13c.55 0 1-.45 1-1v-2h2c.55 0 1-.45 1-1V20.47c.01-2.83-2.19-5.03-5.01-5.03m-5.62 3.06-1.59 1.15.57.81c.64.97.67 2.41-.3 3.13-.48.36-.81.61-1.12.72l-2.05-3.26a.994.994 0 0 1 .26-1.34l3.35-2.42a.753.753 0 0 1 .88 1.22Z"/>
</svg>

    );
  }
}
